//Author June Leow
//Date June 12th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, deleteAPICallGenerator, callBackGenerator} from '../../util/util';
import {Card, CardHeader, CardBody, Row, Col, Input, Button} from 'reactstrap';
import {NavLink, useParams} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {
  appraiser:{
    first_name:'',
    last_name:''
  }
};

//reducer function that perform state update
const reducer = getReducer();


const BaseFee  = (props)=>{
  const controller = new AbortController();

  let id = useParams().id;
  let email = useParams().email;
  let newInitialState = Object.assign({}, initialState, {
    id:id,
    email:email
  });

  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGetNoToken = getAPICallGenerator(props, {signal:controller.signal, noToken:true});
  const httpPutNoToken = putAPICallGenerator(props, {signal:controller.signal, noToken:true});

  //run only once when component is loaded
  useEffect(()=>{
    getAppraiser();
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state

  //API call
  const getAppraiser=()=>{
    const callBack = apiCallBack([{state:'appraiser', key:'data'}]);
    httpGetNoToken('appraiser/public/get/'+state.id+'/'+state.email, '', 'Oops, something went wrong and could not load the appraisal information. Please try again later.', callBack);
  }

  const updateBaseFee=()=>{
    let parameters = [
      {
        field:'ID',
        value:state.id
      },
      {
        field:'email',
        value:state.email
      },
      {
        field:'fee',
        value:state.fee
      }
    ];

    httpPutNoToken('appraiser/public/fee/update', parameters, 'Base fee updated successfully.', 'Oops, something went wrong and could not update your base fee. Please try again later.', ()=>{});
  }

  //render
  let topBar;
  let token = localStorage.getItem('token');

  if(!token)
    topBar = <div className="topbar">
        <div className="topbar-logo-container">
          <NavLink to="/"><img className="topbar-logo-img" alt="@Home VMS Logo" width="120px" src="/img/logo_small.png"/></NavLink>
        </div>
    </div>;
  return (
    <div>
      {topBar}
      <div className="padding">
        <Row>
          <Col sm="1">

          </Col>
          <Col sm="10">
            <Card style={{background:'#f5f5f5'}}>
              <CardHeader className="header-color">
                <center>
                    <i className="fa fa-edit"></i> Setting Base Fee
                </center>
              </CardHeader>
              <CardBody>
                <div>
                  <b>{state.appraiser.first_name+' '+state.appraiser.last_name}</b>
                </div>
                <br/>
                <i>Please enter your base fee for conventional SFR 1004 & Condo 1073</i>
                <br/>
                <br/>
                <Row>
                  <Col sm="4">
                    <label>Base Fee ($)</label>
                  </Col>
                  <Col sm="8">
                    <Input type="number" value={state.fee} onChange={(e)=>setState({fee:e.target.value})}/>
                  </Col>
                </Row>
                <br/><br/>
                <center>
                  <Button color="warning" onClick={(e)=>updateBaseFee()}>Submit</Button>
                </center>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}


export default BaseFee;
